import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export const PublicRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isAuthenticated) {
    // ログインページからのアクセスの場合、元のページまたは/payment_reportsにリダイレクト
    if (location.pathname === '/login') {
      const from = location.state?.from || '/payment_reports';
      return <Navigate to={from} replace />;
    }
    // その他のページからのアクセスの場合、元のページにリダイレクト
    return <Navigate to={location.pathname} replace />;
  }

  return <Outlet />;
};
